import { SortOptionType } from '@bytel/product-wall';
import { FilterType, TopFilterType } from '@bytel/product-wall/types';

export enum WallType {
    PHONE = 'phone',
    ACCESSORY = 'accessory',
    HOTSPOT = 'device_faim',
    SALES_PHONE = 'sales_phone',
    SALES_ACCESSORY = 'sales_accessory',
    ODR = 'odr',
    KIDS_WATCH = 'kids_watch',
}

export type WallConfigType = {
    baseUrl: string;
    baseTitle: string;
    productType: string;
    breadcrumb: {
        baseText: string;
        title: string;
    };
    productByPage: number;
    minProductsToIndex: number;
    filters: ExtendedFilterType[];
    filtersObject: Record<string, FilterType>;
    sorter: Record<string, SortOptionType>;
    filtersOrder: string[];
    topFilters?: Record<string, TopFilterType>;
};

export type ExtendedFilterType = FilterType & {
    isHiddenForPro?: boolean;
};

export type WallConfigFileType = Record<WallType, Omit<WallConfigType, 'filtersObject'>>;

export type EligibilityConfigType = {
    technoToDisplayIfAlone?: string;
};

export type AppConfigType = {
    walls: WallConfigFileType;
    eligibility: EligibilityConfigType;
    features: Record<string, boolean>;
};
